export default "/profile/images/tiktok_btn.svg?104844a761c7ad4d1b0c5bd59ddcb1c2";